import script from "./pc-module-sub-title-4.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-sub-title-4.vue?vue&type=script&setup=true&lang=tsx"

const __exports__ = script;

export default __exports__